<script setup>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import '@jobinsjp/vue3-datatable/dist/style.css';
import { DataTable, TableBody, TableHead, TableBodyCell } from '@jobinsjp/vue3-datatable';
import { truncate } from 'lodash';
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import Swal from 'sweetalert2';
import _, { uniqWith } from 'lodash';
import axios from "axios";
import { authHeader } from "../../helpers/authservice/auth-header";

const store = useStore();
const loading = computed(() => store.state.globals.loading);
const lgus = computed(() => store.state.lgu.dropdownLGUs)
const title = ref("Users List");
const items = ref([
  {
      text: "Home",
      href: "/"
    },
      {
      text: "User Management",
    },
    {
      text: "LGU Access",
      active: true,
    }
])

const query = ref({
    search: ''        
})

const users = ref([]);
const pagination = ref({
  page: 1,
  total: null,
  per_page: 10
});

const checkItems = ref([]);

const getAllUsers = async (dt) => {
  store.dispatch('globals/loading', null, { root: true });

  try {
    const { data } = await axios.get('/users', {
      params: {
        page: dt.page,
        pageSize: dt.per_page,
        sortColumn: 'name',
        search: dt.search,
        orderBy: 'asc'
      },
      headers: authHeader()
    })

    users.value = data.data;
    pagination.value.page =  data.meta.current_page;
    pagination.value.total = data.meta.total;
    pagination.value.per_page = data.meta.per_page;

    fetchExistingCheckedItems();

    store.dispatch('globals/loaded', null, { root: true });
  } catch (err) {
    console.log(err);
    store.dispatch('globals/loaded', null, { root: true });
  }
};

function getUserRoles(values) {
  if (values.length > 0) {
    let roles = [];
    values.forEach((value) => {
      roles.push(value.name);
    })

    return roles.join(', ');
  }
  return 'N/A';
}

const fetchExistingCheckedItems =  () => {
    if (users.value.length) {
      users.value.forEach((user) => {
        if (user.lgus.length > 0) {
          user.lgus.forEach((lgu) => {
          checkItems.value.push(`{ "${user.id}": "${lgu.id}" }`);
          })
        }
      });
    }
}


const updateLGUAccess = async (user_id, name, roles) =>  {
    if (!user_id) return;

    const string_user_id = user_id.toString();

    const confirm = await Swal.fire({
      icon: 'info',
      title: 'Continue?',
      text: `Do you want to update ${name}'s LGU access?`,
      showCancelButton: true,
      confirmButtonText: 'Update',
    })

  if (!confirm.isConfirmed) {
    return;
  }

  try {
      let arrayRoles = [];
      const uniqueCheckItems = uniqWith(checkItems.value, _.isEqual);

      if (roles.length) {
        arrayRoles = roles.map(role => role.id)
      }

      if (uniqueCheckItems.length) {
        let arrayLGUs = [];
        for (const item of uniqueCheckItems) {
          if (Object.keys(JSON.parse(item))[0] !== string_user_id) {
            continue;
          }

          const lgu_id = Object.values(JSON.parse(item))[0];
          arrayLGUs.push(lgu_id);
        }

        await store.dispatch('user/updateUserLGUAccess', { user_id, name, lgus: arrayLGUs, roles: arrayRoles })
    }
  } catch (err) {
    console.log(err);
    store.dispatch('globals/loaded', null, { root: true });
  }
}

onMounted(async () => {
  await store.dispatch('lgu/getDropdownLGUs');
});
</script>

<template>
  <Layout>
      <PageHeader :title="title" :items="items" />
       <b-overlay :show="loading">
          <div class="d-flex mb-4 justify-content-between">
            <div>
              <h1 class="fs-4 text">Users' LGU Access</h1>
              <small>Check and set the user's LGU access</small>
            </div>
          </div>

          <div class="row">
            <div class="col lg-12">
                <data-table :rows="users"
                    :pagination="pagination"
                    striped
                    :query="query"
                    filter
                    :loading="loading"
                    hoverable
                    sortable
                    @loadData="getAllUsers"
                >
                  <template #thead>
                      <table-head>Name</table-head>
                      <table-head v-for="lgu in lgus" :key="lgu.id">{{ lgu.name }}</table-head>
                      <table-head>Action</table-head>
                  </template>

              <template #tbody="{row}">
                  <table-body>
                    <strong :title="row.name">{{ truncate(row.name, { length: 24 }) }}</strong>
                    <div class="text-muted fs-6 text" :title="getUserRoles(row.roles)">{{ truncate(getUserRoles(row.roles), { length: 30 }) }}</div>
                  </table-body>
                 <table-body v-for="(lgu) in lgus" :key="lgu.id">
                    <input v-model="checkItems" type="checkbox"
                          :value='`{ "`+row.id+`": "`+lgu.id+`" }`' />
                  </table-body>
                  <table-body>
                    <div class="text-muted">
                      <span class="mr-1" :title="row.name">{{ truncate(row.name, { length: 24 }) }}</span>
                      <span class="text-muted fs-6 text" :title="getUserRoles(row.roles)">({{ truncate(getUserRoles(row.roles), { length: 30 }) }})</span>
                    </div>
                     <button
                        class="btn btn-secondary mr-1"
                        title="Update LGU Access"
                        @click.prevent="updateLGUAccess(row.id, row.name, row.roles)"
                      >
                      <i class="mdi mdi-account-check label-icon align-middle fs-4 text mr-2"></i>Update LGU Access
                    </button>
                  </table-body>
              </template>
                  <template #empty>
                    <TableBodyCell colspan="10">
                        No users found
                    </TableBodyCell>
                </template>
              </data-table>
            </div>
          </div>
      </b-overlay>
  </Layout>
</template>